module.exports = __webpack_public_path__ + "static/media/bot.73dc0c12.svg";